// Lightweight haptic-feedback wrapper around the Web Vibration API.
// Mirror of iOS `Feedback` (Settings.swift). Each call silently no-ops
// when the browser doesn't support `navigator.vibrate` (notably iOS
// Safari refuses to implement) or when the user has the toggle off.
//
// The pattern arrays are ms durations alternating between vibrate /
// pause. Kept small (≤80ms) so a misfire doesn't startle.

const STORAGE_KEY = 'hm.haptics.v1';

export function getHapticsEnabled(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    // Default ON for new users — matches iOS default.
    return raw == null ? true : raw === '1';
  } catch { return true; }
}

export function setHapticsEnabled(on: boolean): void {
  if (typeof window === 'undefined') return;
  try { localStorage.setItem(STORAGE_KEY, on ? '1' : '0'); }
  catch { /* ignore */ }
}

function fire(pattern: number | number[]): void {
  if (typeof window === 'undefined') return;
  if (!getHapticsEnabled()) return;
  // Older lib.dom.d.ts versions type vibrate as `(p: Iterable<number>) => boolean`,
  // refusing the `number` overload that browsers actually accept. Cast both
  // params + the receiver through `any` to dodge the lib version drift.
  const nav = navigator as unknown as { vibrate?: (p: unknown) => boolean };
  if (typeof nav.vibrate !== 'function') return;
  try { nav.vibrate(pattern); }
  catch { /* ignore — some browsers throw on certain patterns */ }
}

export const Haptics = {
  /// Fired on every tile placement / move. Light tick.
  tilePlaced(): void { fire(8); },
  /// Fired on returning a tile to the bag / soft action.
  tilePicked(): void { fire(4); },
  /// Fired when the player tries to place on an invalid cell.
  invalid(): void { fire([12, 30, 12]); },
  /// Fired the moment the puzzle is solved.
  solved(): void { fire([20, 40, 20, 40, 60]); },
};
